import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {entities as entitiesAct} from 'actions'
import useUserLoginStatus from './useUserLoginStatus'

export default function useLeverageDataProvider (symbol) {
  const dispatch = useDispatch()
  const isLogin = useUserLoginStatus()
  const fetchData = useCallback(async () => {
    const res = await ApiSdk.futures.getUserLeverage(symbol)
    if (!res?.hasOwnProperty('error') && res?.length > 0) {
      dispatch(entitiesAct({leverageData: {curLeverage: res?.[0]?.leverage}}))
    }
  }, [dispatch, symbol])

  useEffect(() => {
    if (!isLogin) return
    fetchData()
  }, [dispatch, fetchData, isLogin])
}
